(() => {
  if (window.__osmodiGrowthPass2) return;
  window.__osmodiGrowthPass2 = true;

  const q = (selector, root = document) => root?.querySelector(selector) || null;
  const qa = (selector, root = document) => Array.from(root?.querySelectorAll(selector) || []);

  const paintCount = (count) => {
    if (!Number.isFinite(count) || count < 0) return;
    qa('[data-v4-cart-count]').forEach((badge) => {
      badge.textContent = String(count);
      badge.hidden = count === 0;
    });
  };

  const updateCount = (cart) => {
    paintCount(Number(cart?.item_count || 0));
  };

  const enhanceCartSummary = (root = document) => {
    const summary = q('.cart-drawer__summary', root);
    const details = q('.cart-summary__details', summary);
    const totals = q('.cart-totals', details);
    if (!summary || !details || !totals || q('.osmodi-cart-detail-toggle', totals)) return;

    const actions = q('.cart-actions', totals);
    const taxNote = q('.cart-totals__tax-note', totals);
    const promise = q('.osmodi-cart-promise', details);
    const controlled = [actions, taxNote, promise].filter(Boolean);

    controlled.forEach((node, index) => {
      if (!node.id) node.id = `osmodi-cart-detail-${index + 1}`;
    });

    const toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'osmodi-cart-detail-toggle';
    toggle.setAttribute('aria-controls', controlled.map((node) => node.id).join(' '));
    toggle.innerHTML = '<span>Discounts & delivery</span><span class="osmodi-cart-detail-toggle__icon" aria-hidden="true"></span>';

    const setExpanded = (expanded) => {
      toggle.setAttribute('aria-expanded', String(expanded));
      summary.dataset.detailsExpanded = String(expanded);
      controlled.forEach((node) => { node.hidden = !expanded; });
    };

    toggle.addEventListener('click', () => {
      setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
    });

    totals.append(toggle);
    setExpanded(false);
  };

  const replaceDrawer = (html, options = {}) => {
    if (!html) return false;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const incoming = q('#shopify-section-cart-drawer-section', parsed);
    const current = q('#shopify-section-cart-drawer-section');
    if (!incoming || !q('#cart-drawer', incoming)) return false;

    if (!current) {
      document.body.append(incoming);
      enhanceCartSummary(document);
      return true;
    }

    const currentContent = q('.cart-drawer__content', current);
    const currentRail = q('.osmodi-cart-recommendations__rail', current);
    const scrollTop = currentContent?.scrollTop || 0;
    const railScrollLeft = currentRail?.scrollLeft || 0;

    if (options.preserveRecommendations) {
      const currentItems = q('.cart-drawer__items', current);
      const incomingItems = q('.cart-drawer__items', incoming);
      const currentProducts = q('.cart-items__wrapper', currentItems);
      const incomingProducts = q('.cart-items__wrapper', incomingItems);

      if (currentItems && incomingItems && currentProducts && incomingProducts) {
        currentProducts.replaceWith(incomingProducts);

        [
          '.theme-drawer__title',
          '.osmodi-cart-shipping',
          '.cart-totals__original-container',
          '[data-cart-subtotal]',
          '.osmodi-cart-promise'
        ].forEach((selector) => {
          const currentNode = q(selector, current);
          const incomingNode = q(selector, incoming);
          if (!currentNode || !incomingNode) return;
          currentNode.innerHTML = incomingNode.innerHTML;
          incomingNode.getAttributeNames().forEach((name) => currentNode.setAttribute(name, incomingNode.getAttribute(name)));
        });

        currentContent.scrollTop = scrollTop;
        currentRail.scrollLeft = railScrollLeft;
        requestAnimationFrame(() => {
          currentContent.scrollTop = scrollTop;
          currentRail.scrollLeft = railScrollLeft;
        });
        return true;
      }
    }

    current.replaceWith(incoming);
    enhanceCartSummary(document);

    if (options.preserveScroll) {
      const nextContent = q('#cart-drawer .cart-drawer__content');
      const nextRail = q('#cart-drawer .osmodi-cart-recommendations__rail');
      if (nextContent) nextContent.scrollTop = scrollTop;
      if (nextRail) nextRail.scrollLeft = railScrollLeft;
      window.requestAnimationFrame(() => {
        if (nextContent) nextContent.scrollTop = scrollTop;
        if (nextRail) nextRail.scrollLeft = railScrollLeft;
      });
    }

    return true;
  };

  const openDrawer = async () => {
    if (!q('#cart-drawer')) await ensureDrawer().catch(() => false);
    const drawer = q('#cart-drawer');
    if (!drawer) {
      window.location.assign('/cart');
      return;
    }
    try {
      await customElements.whenDefined('theme-drawer');
      drawer.setAttribute('no-persist', '');
      if (typeof drawer.open === 'function') drawer.open();
      document.body.classList.add('v4-cart-open');
    } catch (_) {}
  };

  const fetchCart = async () => {
    const response = await fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to refresh your bag.');
    return response.json();
  };

  const fetchDrawerMarkup = async () => {
    const sectionPath = window.location.pathname === '/cart' ? '/' : window.location.pathname;
    const response = await fetch(`${sectionPath}?sections=cart-drawer-section`, {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to refresh your bag.');
    const payload = await response.json();
    return payload['cart-drawer-section'] || '';
  };

  const ensureDrawer = async () => {
    if (q('#cart-drawer')) return true;
    const drawerMarkup = await fetchDrawerMarkup();
    return replaceDrawer(drawerMarkup);
  };

  const refreshDrawer = async () => {
    const [cart, drawerMarkup] = await Promise.all([fetchCart(), fetchDrawerMarkup()]);
    replaceDrawer(drawerMarkup);
    updateCount(cart);
    injectSetProgress(cart);
    return cart;
  };

  const injectSetProgress = () => {
    qa('.osmodi-set-progress').forEach((node) => node.remove());
  };

  const submitPdp = async (form, submitter = null) => {
    const section = form.closest('.section-osmodi-oc-product');
    const purchaseButtons = qa('[data-oc-main-add], [data-oc-sticky-add]', section || document);
    const selectedTitle = q('[data-oc-variant-choice][aria-current="true"]', section || document)?.dataset.variantTitle || '';
    const buttonStates = purchaseButtons.map((button) => {
      const label = q('span', button) || button;
      return { button, label, original: label.textContent };
    });

    buttonStates.forEach(({ button, label }) => {
      button.disabled = true;
      button.dataset.osmodiState = 'loading';
      button.setAttribute('aria-busy', 'true');
      label.textContent = selectedTitle ? `Adding ${selectedTitle}` : 'Adding';
    });

    try {
      const data = new FormData(form);
      const id = Number(data.get('id'));
      const quantity = Number(data.get('quantity') || 1);
      if (!id) throw new Error('Choose an available size.');
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id, quantity }],
          sections: ['cart-drawer-section'],
          sections_url: window.location.pathname
        })
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'Unable to add this fragrance.');

      const visibleCount = Number(q('[data-v4-cart-count]')?.textContent || 0);
      paintCount(visibleCount + quantity);
      replaceDrawer(payload.sections?.['cart-drawer-section']);
      await openDrawer();

      buttonStates.forEach(({ button, label }) => {
        button.dataset.osmodiState = 'success';
        button.removeAttribute('aria-busy');
        label.textContent = selectedTitle ? `Added ${selectedTitle}` : 'Added to cart';
      });

      const [cartResult] = await Promise.allSettled([fetchCart()]);
      const cart = cartResult.status === 'fulfilled' ? cartResult.value : null;
      if (cart) {
        updateCount(cart);
        injectSetProgress(cart);
      }
      if (cartResult.status === 'rejected') {
        console.warn('[osmodi] Bag refresh completed with a partial response.');
      }
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, payload } }));
    } catch (error) {
      console.warn('[osmodi] Unable to add this fragrance.', error);
      buttonStates.forEach(({ button, label }) => {
        button.dataset.osmodiState = 'error';
        button.removeAttribute('aria-busy');
        label.textContent = 'Try again';
      });
    } finally {
      window.setTimeout(() => {
        buttonStates.forEach(({ button, label, original }) => {
          button.disabled = false;
          button.removeAttribute('aria-busy');
          delete button.dataset.osmodiState;
          label.textContent = original;
        });
      }, 1200);
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target.closest('[data-osmodi-pdp-form]') : null;
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const submitter = event.submitter instanceof HTMLButtonElement ? event.submitter : null;
    submitPdp(form, submitter);
  });

  document.addEventListener('cart:updated', async (event) => {
    const cart = event.detail?.cart || await fetchCart().catch(() => null);
    if (cart) injectSetProgress(cart);
  });

  document.addEventListener('shopify:cart:lines-update', (event) => {
    event.promise
      ?.then(({ cart, detail }) => {
        const count = Number(cart?.totalQuantity ?? detail?.itemCount);
        paintCount(count);
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[osmodi] Unable to sync the bag count.', error);
      });
  });

  document.addEventListener('theme-drawer:open', async (event) => {
    if (!(event.target instanceof HTMLElement) || event.target.id !== 'cart-drawer') return;
    enhanceCartSummary(document);
    const cart = await fetchCart().catch(() => null);
    if (cart) injectSetProgress(cart);
  });

  document.addEventListener('shopify:section:load', async () => {
    enhanceCartSummary(document);
    const cart = await fetchCart().catch(() => null);
    if (cart) injectSetProgress(cart);
  });

  enhanceCartSummary(document);
  if (window.location.pathname !== '/cart' && !q('#cart-drawer')) {
    ensureDrawer().catch((error) => console.warn('[osmodi] Unable to restore the bag drawer.', error));
  }

  window.OSMODIGrowth = { refreshDrawer, openDrawer, fetchCart, injectSetProgress, replaceDrawer, updateCount, enhanceCartSummary };
})();
